import { OptionModel } from "../../common/types/OptionModel";

export const customerMatchStatus: OptionModel[] = [
    {
        value: 0,
        label: "Tümü"
    },
    {
        value: 1,
        label: "Kullanıcı Atanmış"
    },
    {
        value: 2,
        label: "Kullanıcı Atanmamış"
    }
];